module.exports = __webpack_public_path__ + "static/media/CentraleSansBook.148654bb.ttf";